module.exports = __webpack_public_path__ + "img/baoshui.a6c82f74.png";